var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "modal" }, [
        _c("div", { staticClass: "modal-bg" }),
        _c(
          "div",
          { staticClass: "modal-content", style: { width: _vm.width } },
          [
            _c("div", { staticClass: "close", on: { click: _vm.cancel } }, [
              _vm._m(0),
            ]),
            _c(
              "div",
              { staticClass: "modal-content-container" },
              [
                _c("svg-icon", {
                  staticClass: "modal-content-img",
                  class: _vm.iconClassName,
                  staticStyle: { stroke: "currentColor" },
                  attrs: { "icon-class": _vm.iconClass, size: "28" },
                }),
                _c("div", { staticClass: "modal-content-right" }, [
                  _c("div", {
                    staticClass: "delete-tips overflowOuto",
                    domProps: { innerHTML: _vm._s(_vm.tips) },
                  }),
                ]),
              ],
              1
            ),
            !_vm.noBtn
              ? [
                  !_vm.noCancelBtn
                    ? _c("div", { staticClass: "modal-content-btn" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn comfirm",
                            style: { background: _vm.sureBtnBgColor },
                            on: { click: _vm.sure },
                          },
                          [_vm._v(_vm._s(_vm.sureBtnText) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "btn cancel",
                            style: { background: _vm.cancelBtnBgColor },
                            on: { click: _vm.cancel },
                          },
                          [_vm._v(_vm._s(_vm.cancelBtnText) + " ")]
                        ),
                      ])
                    : _c("div", { staticClass: "modal-content-btn2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn comfirm",
                            style: {
                              background: _vm.sureBtnBgColor,
                              ..._vm.sureBtnStyle,
                            },
                            on: { click: _vm.sure },
                          },
                          [_vm._v(" " + _vm._s(_vm.sureBtnText) + " ")]
                        ),
                      ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "el-icon-close" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }